// Captures UTM / referrer attribution into localStorage so it survives the
// hop from the landing page to /quiz (same origin, shared storage).
// NOTE: stores only NON-SENSITIVE marketing attribution (utm_*, referrer,
// landing path), no PII, credentials, or tokens. localStorage is intentional
// here so the value persists across the landing→quiz navigation.
// First-touch is preserved: referrer/landing are only set once; utm_* update
// when a later visit arrives with fresh campaign params.
const KEY = "saebit_attribution";
const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"];

export function captureAttribution() {
  try {
    const params = new URLSearchParams(window.location.search);
    const hasUtm = UTM_KEYS.some((k) => params.get(k));
    let stored = null;
    try {
      stored = JSON.parse(localStorage.getItem(KEY) || "null");
    } catch {
      stored = null;
    }
    if (stored && !hasUtm) return stored;
    const data = stored || {};
    UTM_KEYS.forEach((k) => {
      const v = params.get(k);
      if (v) data[k] = v;
    });
    if (!data.referrer) data.referrer = document.referrer || "";
    if (!data.landing_page) data.landing_page = window.location.pathname + window.location.search;
    localStorage.setItem(KEY, JSON.stringify(data));
    return data;
  } catch {
    return {};
  }
}
